import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import { customAlphabet } from "nanoid";
import ArcoVue from "@arco-design/web-vue";
import "@arco-design/web-vue/dist/arco.css";

import i18n from "./locale";
import { decodeUrlParams } from "./utils/public.js";
import "./styles/variables.scss";

const app = createApp(App);
// 无大写的 I 和 小写的 l
const nanoid = customAlphabet(
    "0123456789ABCDEFGHJKLMNOPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz",
    32
);
window.web_id = nanoid(); //=> "Kqx6yK7L3gTA" 12位
const browserId = ["", null, undefined, "undefined", "null"].includes(
    localStorage.getItem("browserId")
)
    ? nanoid()
    : localStorage.getItem("browserId");
localStorage.setItem("browserId", browserId);

const gid = 13;
const appid = gid === 13 ? 6689 : 302906;
// Tea初始化
window.collectEvent("init", {
    app_id: appid,
    channel: "va", // va || sg
    channel_domain: 'https://mcs-nontt.byteintlapi.com' // 替换为目标域名
    // max_report: 1 // 拆成单条上报，用于监控成功和失败的事件
});
const urlParams = decodeUrlParams() || {}; // 获取url参数
// 先判断是否有指纹
const configParam = {
    // Tea公参
    app_id: appid,
    time: Math.floor(Date.now() / 1000),
    user_unique_id: browserId,
    role_uuid: urlParams.puid || '',
    region: "JP",
};
window.collectEvent("config", configParam);
window.collectEvent("start");

// mobile调试
// const vConsole = new VConsole()
// app.use(vConsole);

// 全局错误处理
app.config.errorHandler = (err, instance, info) => {
    console.error("Global error:", err, info);
    // 发送错误日志到监控平台
    // sendErrorLog({
    //     type: 'vue-error',
    //     message: err.message,
    //     stack: err.stack,
    //     component: instance?.$options?.name || 'unknown',
    //     info // 错误发生的位置信息
    // })
};

app.use(router);
app.use(ArcoVue); // 使用 ArcoVue 组件库
app.use(i18n); // 使用 i18n 国际化插件
app.mount("#app");
